export default "__VITE_ASSET__V4U829eS__"